export const ADMIN_PATH = "/admin9982649982mys986532";